import React from "react";
import { observer } from "mobx-react-lite";
import { GooLoader } from "@gemlightbox/core-kit";

import { useStores } from "src/hooks";
import {
  PageResultsEmpty,
  PageResultsPlaceholderContainer,
  ProductsEmpty,
} from "src/external-ts/components";

export const ProductsListPlaceholder: React.FC = observer(() => {
  const { productsStore } = useStores();
  const loading = productsStore.loading;
  const isEmpty = productsStore.totalProductsAmount === 0;

  return (
    <PageResultsPlaceholderContainer>
      {loading && <GooLoader />}
      {!loading && isEmpty && <ProductsEmpty />}
      {!loading && !isEmpty && (
        <PageResultsEmpty
          search={productsStore.filters.title}
          isOnlySearch={productsStore.isOnlySearch}
        />
      )}
    </PageResultsPlaceholderContainer>
  );
});
